import { Box, Card, useTheme } from '@mui/material';
import FlexBox from 'components/flexbox/FlexBox';
import { H3 } from 'components/Typography';
import { useTranslation } from 'react-i18next';

const WelcomeCard = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Card
            sx={{
                padding: 3,
                height: '100%',
            }}
        >
            <FlexBox
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    [theme.breakpoints.down(630)]: {
                        textAlign: 'center',
                        flexDirection: 'column-reverse',
                        '& img': {
                            marginBottom: 1,
                        },
                    },
                }}
            >
                <Box>
                    <H3 mb={0.5} fontWeight={700}>
                        {t('Welcome Back! ') + localStorage.getItem('fullName')}
                    </H3>
                </Box>
            </FlexBox>
        </Card>
    );
};

export default WelcomeCard;
